import { CATEGORY_FILTER_INDICATOR, CATEGORY_FILTER_SEPARATOR } from '~~/constants/typesense';
import type { CategoryTree } from '~~/types/category/CategoryTree';

export const convertCommerceToolsCategories = (
  commerceToolsCategories: Maybe<string[]>,
  categoryTree: CategoryTree,
): string => {

  if (!commerceToolsCategories || !commerceToolsCategories.length) {

    return '';

  }
  const mainCategory = `${categoryTree.typesenseKey}.lvl${commerceToolsCategories.length - 1}`;
  const remainingPath = commerceToolsCategories.join(CATEGORY_FILTER_INDICATOR);
  const typesenseCategoryPath = `${mainCategory}${CATEGORY_FILTER_SEPARATOR}"${remainingPath}"`;

  return typesenseCategoryPath;

};
